/** Import CSS */
import '@/assets/main.scss'
import 'vue-multiselect/dist/vue-multiselect.css'

/** Import Base */
import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'

/** Import app, router, plugins, services */
import App from './App.vue'
import router from './router'
import i18n from '@/translation'
import ApiService from '@/services/ApiService'
import BootstrapBreakpoints from '@/plugins/BootstrapBreakpoints'

/** Create App and use dependencies */
    // Init parameters
const app = createApp(App)
const { t } = i18n.global

    // Load components
app.provide('trans', t)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(BootstrapBreakpoints)
app.component('BreadCrumb', defineAsyncComponent(() => import('@/components/BreadCrumb.vue')))
app.component('Stepper', defineAsyncComponent(() => import('@/components/Stepper.vue')))
app.component('BaseInput', defineAsyncComponent(() => import('@/components/Form/BaseInput.vue')))
app.component('BaseSelect', defineAsyncComponent(() => import('@/components/Form/BaseSelect.vue')))
app.component('VueMultiselect', defineAsyncComponent(() => import('vue-multiselect/src/Multiselect.vue')))
app.component('StatusPill', defineAsyncComponent(() => import('@/components/Pills/StatusPill.vue')))
app.component('PageLoader', defineAsyncComponent(() => import('@/components/Layout/PageLoader.vue')))
/** Globals configs */
import VueFilters from '@/helpers/Filters'
app.config.globalProperties.$filters = VueFilters

/** Register directives */
import BootstrapTooltip from '@/plugins/BootstrapTooltip'
app.directive('tooltip', BootstrapTooltip)

/** Register Services */
ApiService.init(app)

/** Render app */
app.mount('#app')
